import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


const store=new Vuex.Store({

state:{
  avatar:localStorage.getItem('avatar'),
  nickname:localStorage.getItem('nickname'),
  token:localStorage.getItem('token'),
  // token:"fc3231a1f31e55b34b86a33df8e69f70",
  Access_token:localStorage.getItem('Access_token'),
  appid:localStorage.getItem('appid'),
  nonceStr:localStorage.getItem('nonceStr'),
  signature:localStorage.getItem('signature'),
  ticket:localStorage.getItem('ticket'),
  timestamp:localStorage.getItem('timestamp'),
  timestamp1:localStorage.getItem('timestamp1'),
}

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js